module.exports = __webpack_public_path__ + "static/media/arrow-circle-down-solid.e993f0ca.svg";